import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  heightThreshold: 250,
  stickyCssClass: 'sticky-container--sticky',
};

export default class StickyContainer extends Component {
  static selector = '[data-comp-sticky-container]';

  constructor(el, options = DEFAULTS) {
    super(el, options);

    this.parentContainer = this.$container.parentElement;
    this.init();
  }

  init() {
    const parentHeight = this.parentContainer.getBoundingClientRect().height;
    const containerHeight = this.$container.getBoundingClientRect().height;

    if ((parentHeight - containerHeight) > this.$options.heightThreshold) {
      this.$container.classList.add(this.$options.stickyCssClass);
    }
  }
}
